export enum DROPDOWN_MENU_DENSITY {
  COMPACT = 'compact',
  DEFAULT = 'default',
}
export enum DropdownMenuItemVariant {
  DEFAULT = 'default',
  DESTRUCTIVE = 'destructive',
}
